import { IBooking, IPageInfo, Order } from '@api'
import { IGridTableCell, GridTableStatusEnum } from '@ui'
import { ISelection } from '../hooks/useSelection'

export interface Sort {
  column: string
  order: Order
}

export interface GetVariablesFunc<FilterT extends BaseTableFilters = BaseTableFilters> {
  sort: Sort
  after?: string | null
  first?: number
  filters: FilterT
}

export enum Actions {
  LOAD_START,
  LOAD_START_WITHOUT_SKELETON,
  LOAD,
  SORT,
  SET,
  NEXT_PAGE,
  QUERY,
  ERROR,
  OPTIMISTIC_DELETE,
  TOGGLE_INCLUDE_OLD,
  RESET_FILTERS,
  FILTER,
}

export interface BaseTableFilters {
  query: string
  fromDate: Date | null
  toDate: Date | null
}

export interface LoadStartAction {
  type: Actions.LOAD_START
  reqId: string
}

export interface LoadStartActionWithoutSkeleton {
  type: Actions.LOAD_START_WITHOUT_SKELETON
  reqId: string
}

export interface SortAction {
  type: Actions.SORT
  column: string
}

export interface NextPageAction {
  type: Actions.NEXT_PAGE
}

export interface QueryAction {
  type: Actions.QUERY
  query: string
}

export interface ErrorAction {
  type: Actions.ERROR
  reqId: string
}

export interface OptimisticDeleteAction {
  type: Actions.OPTIMISTIC_DELETE
  ids: string[]
}

export interface ToggleIncludeOldAction {
  type: Actions.TOGGLE_INCLUDE_OLD
}

export interface ResetFiltersAction {
  type: Actions.RESET_FILTERS
}

export interface ApplyFiltersAction<FilterT extends BaseTableFilters> {
  type: Actions.FILTER
  filters: FilterT
}

export type ActionBase<FilterT extends BaseTableFilters = BaseTableFilters> =
  | LoadStartAction
  | NextPageAction
  | SortAction
  | QueryAction
  | ErrorAction
  | LoadStartActionWithoutSkeleton
  | OptimisticDeleteAction
  | ToggleIncludeOldAction
  | ResetFiltersAction
  | ApplyFiltersAction<FilterT>

export interface UseBookingsTableHook<FilterT extends BaseTableFilters = BaseTableFilters> {
  reqId: string
  filters: FilterT
  status: GridTableStatusEnum
  count: number
  items: IGridTableCell<IBooking>[]
  sort: Sort
  first?: number
  after?: string | null
  pageInfo?: IPageInfo
  nextPage?: () => void
  optimisticDelete?: (ids: string[]) => void
  fetchExportLink?: () => Promise<string>
  sortBy: (column: string) => void
  selection?: ISelection
  resetFilters: () => void
  applyFilters: (filters: FilterT) => void
}
